import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'clever-klasse',
    templateUrl: './klasse.component.html',
    styleUrls: ['./klasse.component.scss'],
    standalone: false
})
export class KlasseComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @Input() mode: string;
    isBrowser: boolean = false;
    currentTarif: string = '';
    currentWagenClass: string = '';

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    selectTarif(tarif): void {
        if (this.currentTarif === tarif) {
            this.currentTarif = '';
        } else {
            this.currentTarif = tarif;
        }
        this.hotelService.tarifclass(this.currentTarif, this.mode !== 'home');
    }

    selectbookingClass(klass): void {
        if (this.currentWagenClass === klass) {
            this.currentWagenClass = '';
        } else {
            this.currentWagenClass = klass;
        }
        this.hotelService.bookingClass(this.currentWagenClass, this.mode !== 'home');
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.currentTarif = filter.flight?.tariff;
            this.currentWagenClass = filter.flight?.bookingClass;
            this.cdr.markForCheck();
        });
    }
}
